<script lang="ts">
	import { t } from '$lib/i18n';
	import { isProduction } from '$lib/web3/client';

	// Improved preload function with error handling
	function preload(src: string): Promise<void> {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.onload = () => resolve();
			img.onerror = () => reject(new Error(`Failed to preload image: ${src}`)); // Handle load error
			img.src = src;
		});
	}

	let trapeziumSrc = isProduction
		? 'https://chainparty.xyz/img/landing/intro/trapezium.png'
		: 'https://eicdapp.skywalkerlab.dev/img/landing/intro/trapezium.png';

	let partyChainSrc = isProduction
		? 'https://chainparty.xyz/img/landing/intro/chain party.png'
		: 'https://eicdapp.skywalkerlab.dev/img/landing/intro/chain party.png';

	// Promise.all([preload(trapeziumSrc), preload(partyChainSrc)])
	// 	.then(() => {
	// 		console.log('Images preloaded successfully');
	// 	})
	// 	.catch((error) => {
	// 		console.error(error); // Handle preload errors
	// 	});
</script>

<div
	class="bg-with-opacity flex min-h-screen w-full flex-col items-center justify-center md:pt-[100px]"
>
	<div class=" mx-auto px-4">
		<div class=" ">
			<div class="relative flex h-full w-full max-w-[700px] flex-col items-center">
				{#await preload(partyChainSrc) then _}
					<img src={partyChainSrc} class="lg:h-[80%] lg:w-[80%]" alt="chain_party_mascot" />
				{/await}
				<!-- trapezium container -->
				<div class=" absolute bottom-[2%] flex w-full justify-center px-3">
					{#await preload(trapeziumSrc) then _}
						<img src={trapeziumSrc} alt="trapezium" class="lg:h-[153px] lg:w-[517px]" />
						<div
							class="pixel-font absolute left-[50%] top-[50%] w-[80%] -translate-x-[50%] -translate-y-[50%] px-4 text-center text-[18px]
                                font-bold capitalize tracking-[0.05em] text-white md:w-[65%] md:text-[28px] md:leading-[38.168px]"
						>
							{$t('landing.gamefi')}
						</div>
					{/await}
				</div>
			</div>
			{#await preload(trapeziumSrc) then _}
				<div class=" mx-auto flex items-center justify-center space-x-4 pb-[30px]">
					<div class="font-inter text-xs font-normal uppercase leading-[14.52px] text-white">
						{$t('landing.incubated_by')}
					</div>
					<img src="/img/landing/logo/eic logo.png" alt="eic-logo" class="h-8" />
					<!-- Adjust height as needed -->
				</div>
			{/await}
		</div>
	</div>
</div>

<style>
	.bg-with-opacity {
		position: relative;
		width: 100%;
		min-height: 100vh;
	}

	.bg-with-opacity::before {
		content: '';
		background-image: url('/img/landing/intro/background.jpg');
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		opacity: 1;
		z-index: -2;
	}

	.bg-with-opacity::after {
		content: '';
		background: linear-gradient(
			360deg,
			#110f27 13%,
			rgba(17, 15, 39, 0) 35%,
			rgba(17, 15, 39, 0) 87.5%,
			#110f27 100%
		);
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: -1;
	}
</style>
